'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var linkedListUtils = require('./linked-list-utils.js');

const reduceLinkedList = (cb, initValue, list) => {
    const { items, headId } = list;
    return linkedListUtils.walkListItemRecord((acc, current) => ({
        result: cb(acc, current),
    }), {
        startId: headId,
        items,
        initValue,
    });
};

exports.reduceLinkedList = reduceLinkedList;
//# sourceMappingURL=reduce-linked-list.js.map
